import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FontAudit } from "@/features/admin/components/font-audit";
import { PageContainer } from "@/components/ui/page-container";

function AdminAuditPage() {
  return (
    <PageContainer maxWidth="6xl">
      <FontAudit />
    </PageContainer>
  );
}

export const adminAuditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/audit",
  component: AdminAuditPage,
});
